// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "\r\nhtml, body { height: 100%; }\r\nbody { margin: 0; font-family: Roboto, \"Helvetica Neue\", sans-serif; }\r\n", "",{"version":3,"sources":["styles.css"],"names":[],"mappings":";AACA,aAAa,YAAY,EAAE;AAC3B,OAAO,SAAS,EAAE,iDAAiD,EAAE","file":"styles.css","sourcesContent":["\r\nhtml, body { height: 100%; }\r\nbody { margin: 0; font-family: Roboto, \"Helvetica Neue\", sans-serif; }\r\n"]}]);
// Exports
module.exports = exports;
